export function createContext<T>() {
    let backgroundContext: T | null = null;
    const getContextTasks = new Set<(ctx: T) => void>();

    function setContext(ctx: T) {
        backgroundContext = Object.assign(backgroundContext || {}, ctx);

        getContextTasks.forEach(resolve => {
            resolve(ctx);
        });

        getContextTasks.clear();
    }

    async function getContext() {
        if (backgroundContext) {
            return backgroundContext;
        }

        return new Promise<T>(resolve => {
            getContextTasks.add(resolve);
        });
    }

    return { setContext, getContext } as const;
}
